module.exports = __webpack_public_path__ + "img/phone.76603836.svg";